import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {NavLink} from 'react-router-dom';

import {getAssetPath} from 'epic-diesel-common/src/utils/DieselUtils';
import {generateRoutePath} from 'epic-common/src/route';
import {shapes, sizes} from 'epic-diesel-common/src/constants';

import {Icon, Avatar, Message} from 'epic-diesel-common';

import styles from './NavItem.pcss';

const mapStateToProps = state => ({
    isExpanded: state.getIn(['nav', 'isExpanded'])
});

class NavItem extends PureComponent {
    static propTypes = {
        avatar: PropTypes.string,
        firstInitial: PropTypes.string,
        icon: PropTypes.string,
        iconClass: PropTypes.string,
        isExpanded: PropTypes.bool.isRequired,
        isHeader: PropTypes.bool,
        subtitle: PropTypes.string,
        title: PropTypes.string.isRequired,
        to: PropTypes.string.isRequired
    };

    static defaultProps = {
        isHeader: false
    };

    render() {
        const {
            avatar,
            firstInitial,
            icon,
            iconClass,
            isExpanded,
            isHeader,
            subtitle,
            title,
            to
        } = this.props;

        const linkClasses = cx(styles.link, {[styles.header]: isHeader});

        const titleClasses = cx(styles.titles, {[styles.expanded]: isExpanded});

        const assetSize = isHeader ? sizes.MEDIUM : sizes.XXSMALL;
        const avatarType = isHeader ? shapes.CREST : shapes.ROUND;

        return (
            <NavLink
                className={linkClasses}
                to={generateRoutePath(to)}
                activeClassName={styles.active}>
                <div className={styles.assetWrapper}>
                    {icon && <Icon className={iconClass} icon={icon} size={assetSize} />}

                    {!icon && firstInitial && (
                        <Avatar
                            avatar={avatar && getAssetPath(avatar)}
                            initial={firstInitial}
                            className={styles.avatar}
                            size={assetSize}
                            type={avatarType}
                        />
                    )}
                </div>
                <div className={titleClasses}>
                    {title && (
                        <span className={styles.primary}>
                            {/*
                                temporarily using message component to translate message codes
                                TODO: process account and message data before passing to Nav as strings
                            */}
                            <Message code={title} />
                        </span>
                    )}
                    {subtitle && (
                        <span className={styles.secondary}>
                            <Message code={subtitle} />
                        </span>
                    )}
                </div>
            </NavLink>
        );
    }
}

export default connect(mapStateToProps)(NavItem);
